import { Link } from 'react-router-dom'
import { Phone, Mail, MapPin, Waves } from 'lucide-react'

export function Footer() {
  return (
    <footer className="bg-primary-900 text-white/80">
      <div className="container-content py-12">
        <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
          {/* Brand */}
          <div className="flex flex-col gap-3">
            <div className="flex items-center gap-2 text-white font-heading font-bold text-lg">
              <Waves size={20} aria-hidden="true" />
              Familie Below
            </div>
            <p className="text-sm leading-relaxed text-white/70">
              Ihre private Ferienwohnung in Seebad Bansin auf der Insel Usedom.
              Nur 800 m vom Strand entfernt.
            </p>
          </div>

          {/* Quick links */}
          <nav aria-label="Footer Navigation">
            <p className="text-white text-sm font-semibold uppercase tracking-wide mb-3">Seiten</p>
            <ul className="flex flex-col gap-2">
              {[
                { href: '/',             label: 'Startseite' },
                { href: '/ferienwohnung', label: 'Ferienwohnung' },
                { href: '/lage',          label: 'Lage & Umgebung' },
                { href: '/preise',        label: 'Preise' },
                { href: '/anreise',       label: 'Anreise' },
                { href: '/kontakt',       label: 'Kontakt' },
              ].map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-sm text-white/70 hover:text-white transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          {/* Contact */}
          <address className="not-italic flex flex-col gap-3">
            <p className="text-white text-sm font-semibold uppercase tracking-wide">Kontakt</p>
            <a href="tel:+493837829193" className="flex items-center gap-2 text-sm text-white/70 hover:text-white transition-colors">
              <Phone size={15} aria-hidden="true" />
              038378 29193
            </a>
            <a href="mailto:ebibelow@t-online.de" className="flex items-center gap-2 text-sm text-white/70 hover:text-white transition-colors">
              <Mail size={15} aria-hidden="true" />
              ebibelow@t-online.de
            </a>
            <p className="flex items-start gap-2 text-sm text-white/70">
              <MapPin size={15} className="shrink-0 mt-0.5" aria-hidden="true" />
              Fischerweg 4a<br />17429 Seebad Bansin
            </p>
          </address>
        </div>

        <div className="mt-10 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-white/50">
          <p>© {new Date().getFullYear()} Eberhard Below. Alle Rechte vorbehalten.</p>
          <div className="flex gap-4">
            <Link to="/impressum"   className="hover:text-white transition-colors">Impressum</Link>
            <Link to="/datenschutz" className="hover:text-white transition-colors">Datenschutz</Link>
          </div>
        </div>
      </div>
    </footer>
  )
}
